import { ChakraProvider } from '@chakra-ui/react';
import React from 'react';
import { AuthProvider } from './auth';
import { ToastProvider } from './toast';
import { LoadingProvider } from './loading';
import { theme } from '../styles/theme';

const AppProvider: React.FC = ({ children }) => (
  <ChakraProvider theme={theme}>
    <ToastProvider>
      <LoadingProvider>
        <AuthProvider>{children}</AuthProvider>
      </LoadingProvider>
    </ToastProvider>
  </ChakraProvider>
);

export default AppProvider;
